export const ButtonStyles = {
  // Styles all buttons have in common
  baseStyle: {
    cursor: 'pointer',
    fontWeight: 2,
    fontSize: 1,
    px: '24px',
    py: '10px',
    transform: 'perspective(1px) translateZ(0)',
    transitionDuration: '0.3s',
  },
  // Different button sizes
  sizes: {},
  // Different button variants
  variants: {
    primary: {
      bg: 'primary',
      color: 'white',
      ':hover': {
        textDecoration: 'none',
      },
      textTransform: 'titlecase',
      size: 'lg',
    },
    primaryDark: {
      bg: 'white',
      color: 'primary',
      ':hover': {
        bg: 'primaryLight',
        color: 'primary',
      },
      textTransform: 'titlecase',
      size: 'lg',
    },
    ghost: {
      background: '#fff',
      color: 'primary',
      ':hover': {
        bg: 'primaryLight',
      },
      textTransform: 'titlecase',
      border: '1px solid',
      borderColor: 'primary',
      size: 'lg',
    },
    outline: {
      color: 'white',
      textTransform: 'titlecase',
      border: '1px solid white',
      size: ['md', 'lg'],
      ':hover': {
        bg: 'transparent',
      },
    },
    secondary: {
      color: 'white',
      backgroundColor: 'secondary',
      size: 'lg',
    },
    adminBarButton: {
      display: ['block', 'inline-block'],
      textAlign: 'right',
      mr: '8',
      p: '0',
      bg: 'transparent',
      size: 'lg',
    },
    text: {
      display: ['block', 'inline-block'],
      textAlign: 'left',
      p: '0',
      bg: 'transparent',
      color: 'white',
      fontSize: 'inherit',
      textDecoration: 'underline',
      whiteSpace: 'normal',
      width: '100%',
    },
  },
  // Default size and or variant
  defaultProps: {
    variant: 'primary',
  },
};
